import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "BaseTableHeaderInfo flex items-center" }
const _hoisted_2 = {
  key: 0,
  class: "BaseTableHeaderInfo__status"
}
const _hoisted_3 = { class: "fs-17px fw-600 text-cool-gray-100 text-no-wrap" }
const _hoisted_4 = { class: "fs-15px fw-500 text-info-100 text-no-wrap" }

import { ref, toValue } from 'vue'

interface IProps {
  title: string
  titleColor: string
  itemCount: string | number
  customContainerClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseTableHeaderInfo' },
  __name: 'BaseTableHeaderInfo',
  props: {
    title: {},
    titleColor: {},
    itemCount: {},
    customContainerClass: { default: 'q-pa-sm' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v4ab50ae4": (titleColorRef.value)
}))



const props = __props

const titleColorRef = ref(toValue(() => props.titleColor))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["row items-center no-wrap gap-sm", [__props.customContainerClass]])
    }, [
      (titleColorRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.itemCount) + " Items", 1 /* TEXT */)
    ], 2 /* CLASS */)
  ]))
}
}

})